import { TENANTS } from "../constants"
import { LOG_LEVELS } from "../constants/LogLevels"
import { extractList, sendToLogServer } from "../core/service/BusinessLogicService"
import { digitalJourneyApigateway } from "../intances/apigateway"

/** PDI FR : pays « France » en tête (ex-`priorityCountry` dans extractList, géré via prioritizeFrance). */
export function tenantPrioritizesFranceInCountrySelect(tenant) {
  return (
    tenant === TENANTS.BUT ||
    tenant === TENANTS.CONFORAMA_RETAIL ||
    tenant === TENANTS.CONFORAMA
  )
}

/** Met la France (code ISO FR) en tête des options { value, label } (liste pays). */
export function prioritizeFranceInCountrySelectOptions(options) {
  if (!Array.isArray(options) || options.length === 0) return options
  const idx = options.findIndex((o) => o && String(o.value).toUpperCase() === "FR")
  if (idx <= 0) return options
  const next = [...options]
  const [france] = next.splice(idx, 1)
  return [france, ...next]
}

export function getCountryByCode(tunnelData, { countryCode, languageTag }) {
  const API_URL_GET_COUNTRIES = `middle-business-service/api/v2/repository/countries/codes/`
  const params = new URLSearchParams()
  if (languageTag) params.append("languageTag", languageTag)

  return digitalJourneyApigateway(tunnelData)
    .get(API_URL_GET_COUNTRIES + countryCode + (params.toString() ? `?${params}` : ""))
    .then((response) => {
      const list = extractList(response.data)
      return tenantPrioritizesFranceInCountrySelect(tunnelData?.tenant)
        ? prioritizeFranceInCountrySelectOptions(list)
        : list
    })
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving countries by code, error message => ${error.message}`
      )
      throw error
    })
}
